// extracted by mini-css-extract-plugin
export default {"container":"Text_container_C0jPq","green":"Text_green_IpXe9","subject":"Text_subject_RxvMm","showOriginal":"Text_showOriginal__Ic5n"};